<script setup lang="ts">
const page = usePage().value;
const trekInfo = computed(() => page?.trekInfo ?? []);
</script>

<template>
  <ul v-for="(item, index) in trekInfo" :key="index" class="item">
    <li v-if="item.duration">
      <span>
        <AppSVGBrandIconsAll icon-name="Duration" />
        Duration</span
      >
      <span>{{ item.duration }} nights</span>
    </li>
    <li v-if="item.grading">
      <span v-if="[2, 3, 4].some((grade) => item.grading.includes(grade))">
        <AppSVGBrandIconsAll
          v-if="item.grading.includes(2)"
          icon-name="Trek Grade 2"
        />
        <AppSVGBrandIconsAll
          v-if="item.grading.includes(3)"
          icon-name="Trek Grade 3"
        />
        <AppSVGBrandIconsAll
          v-if="item.grading.includes(4)"
          icon-name="Trek Grade 4"
        />
        Suitability &amp; Grading
      </span>
      <span
        >{{ item.grading }}
        <NuxtLink class="btn" to="/essential-info/trek-grading"
          >View Trek Grading</NuxtLink
        ></span
      >
    </li>
    <li v-if="item.accommodation">
      <span
        ><AppSVGBrandIconsAll icon-name="Accommodation" /> Accommodation</span
      >
      <span>{{ item.accommodation }} </span>
    </li>
    <li v-if="item.meals">
      <span><AppSVGBrandIconsAll icon-name="Meals" /> Meals</span>
      <span>{{ item.meals }} </span>
    </li>
    <li v-if="item.group_sizes">
      <span><AppSVGBrandIconsAll icon-name="Group Size" /> Group size</span>
      <span>{{ item.group_sizes }} </span>
    </li>
    <li v-if="item.bag_transfer">
      <span
        ><AppSVGBrandIconsAll icon-name="Baggage Transfer" /> Bag Transfer</span
      >
      <span>{{ item.bag_transfer }} </span>
    </li>
    <li v-if="item.single_rooms">
      <span>
        <AppSVGBrandIconsAll icon-name="Single Rooms" /> Single Rooms</span
      >
      <span>{{ item.single_rooms }} </span>
    </li>
    <li v-if="item.solo_supplement">
      <span
        ><AppSVGBrandIconsAll icon-name="Solo Supplement" /> Solo
        Supplement</span
      >
      <span>{{ item.solo_supplement }} </span>
    </li>
    <li v-if="page?.setYear1">
      <span>
        <AppSVGBrandIconsAll icon-name="Dates" />
        Dates {{ page?.setYear1 }}</span
      >
      <AppTrekPackagesYear1TrekInBrief
        :parent-page-title="page?.parentPageTitle"
      />
    </li>
    <li v-if="page?.setYear2">
      <span>
        <AppSVGBrandIconsAll icon-name="Dates" /> Dates
        {{ page?.setYear2 }}</span
      >
      <AppTrekPackagesYear2TrekInBrief
        :parent-page-title="page?.parentPageTitle"
      />
    </li>
  </ul>
</template>
